/* unplugin-vue-components disabled */import script from "./customTextWithTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./customTextWithTooltip.vue?vue&type=script&setup=true&lang=js"

import "./customTextWithTooltip.vue?vue&type=style&index=0&id=4c7a8371&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7a8371"]])

export default __exports__